import axiosInstance from '@/lib/axios'
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export const apiClient = {
  get: <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    axiosInstance.get<T>(url, config).then((res: AxiosResponse<T>) => res.data),

  post: <T, D = unknown>(
    url: string,
    data: D,
    config?: AxiosRequestConfig
  ): Promise<T> =>
    axiosInstance.post<T>(url, data, config).then((res: AxiosResponse<T>) => res.data),

  put: <T, D = unknown>(
    url: string,
    data: D,
    config?: AxiosRequestConfig
  ): Promise<T> =>
    axiosInstance.put<T>(url, data, config).then((res: AxiosResponse<T>) => res.data),

  patch: <T, D = unknown>(
    url: string,
    data: D,
    config?: AxiosRequestConfig
  ): Promise<T> =>
    axiosInstance.patch<T>(url, data, config).then((res: AxiosResponse<T>) => res.data),

  delete: <T, D = unknown>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig
  ): Promise<T> =>
    axiosInstance.delete<T>(url, { ...config, data }).then((res: AxiosResponse<T>) => res.data),
};
